import {Helpers} from "../helpers/helpers";

export class TabbedTable {
	private fileSearchQuery: HTMLInputElement;

	private productFilter: HTMLSelectElement;
	private languageSearch: HTMLSelectElement;
	private navTabs: HTMLElement;
	private fileSearchButton: HTMLButtonElement;
	
	constructor() {
		this.init();
	}

	private init() {
		this.productFilter = document.querySelector('.download-list .product-filter') as HTMLSelectElement;
		this.languageSearch = document.querySelector('.download-list .language-search') as HTMLSelectElement;
		this.navTabs = document.querySelector('.nav-tabs') as HTMLElement;
		this.fileSearchButton = document.querySelector('.file-search-wrap .btn-primary') as HTMLButtonElement;
		this.fileSearchQuery = document.querySelector('.file-search-wrap #file-search') as HTMLInputElement;
		
		if (this.productFilter && this.languageSearch) {
			const urlParams = Helpers.getUrlParameters();
			this.languageSearch.value = urlParams['language'] ?? "";
			this.productFilter.value = urlParams['product'] ?? "";


			this.productFilter?.addEventListener('change', (e) => {
				this.fileSearchQuery.value = "";
				this.updateFilters();

			});

			this.languageSearch?.addEventListener('change', (e) => {
				this.fileSearchQuery.value = "";
				this.updateFilters();
			});
		}
		
		if (this.navTabs) {
			this.navTabs.querySelectorAll('.nav-item button').forEach(b => {
				b.addEventListener('click', (e)=>{
					const clickedButton = e.target as HTMLElement;
					const activeTab = clickedButton.getAttribute('aria-controls');
					const urlParams = Helpers.getUrlParameters();
					urlParams["tabPage"] = `${activeTab}|1`;
					Helpers.updateUrl(urlParams);
				})
			
			})
		}
		
		if (this.fileSearchButton) {			
			this.fileSearchQuery.addEventListener('keypress',(e: KeyboardEvent) => {			
				
				if (e.key === "Enter") {
					this.updateFilters();
				}
			})
			this.fileSearchButton.addEventListener('click', (e) => {				
				this.updateFilters();				
			})
		}
		
		
	}
	
	private updateFilters() {
		const productFilter = this.productFilter.value;
		const languageFilter = this.languageSearch.value;
		const searchQuery = this.fileSearchQuery.value;
		const activeTab = this.navTabs.querySelector('.active').getAttribute('aria-controls');
		const urlParams = Helpers.getUrlParameters();
		urlParams["product"] = productFilter;
		urlParams["language"] = languageFilter;	
		if (urlParams["tabPage"]) {
			const currentTabPage = urlParams["tabPage"].split('|');
			urlParams["tabPage"] = currentTabPage[0]+"|1";
		} else {
			urlParams["tabPage"] = `${activeTab}|1`;
		}
		urlParams["search"] = searchQuery;
		
		window.location.href = Helpers.getUpdatedUrl(urlParams);
	}
}